export default __webpack_public_path__ + "static/bnb-3b093f5e02db7b5e83ea2531f00a798f.svg";